import CollapsibleContent from './CollapsibleContent';
import Markdown from 'react-markdown';

interface CollapsibleMarkdownProps {
    title: string
    startingIsCollapsed: boolean
    content: string
}

const CollapsibleMarkdown = (props: CollapsibleMarkdownProps) => {
    return(
        <div>
            <CollapsibleContent title={props.title} startingIsCollapsed={props.startingIsCollapsed}>
                <Markdown>{props.content}</Markdown>
            </CollapsibleContent>
        </div>
    )
}

export default CollapsibleMarkdown;